module.exports = __webpack_public_path__ + "static/media/IMG-8.a4e72817.jpg";